require('./style.less');
module.exports = require('./template.hbs');


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/markup/previewIndicator/bundle.js
 ** module id = 423
 ** module chunks = 0
 **/